// extracted by mini-css-extract-plugin
module.exports = {"popup":"TransparentPopup__popup--3mC","header":"TransparentPopup__header--3_Q","inner":"TransparentPopup__inner--1bu","overlay":"TransparentPopup__overlay--1eT"};